/**
 * Animation GSAP for the Hero Block
 */
document.addEventListener('DOMContentLoaded', function () {
    if (typeof gsap !== 'undefined') {
        gsap.set('.animate-bg', {
            background: 'radial-gradient(16% 16% at 0% 0%,rgba(101, 179, 46, 1) 0%,rgba(0, 0, 0, 0) 100%)',
        });
        gsap.timeline({ repeat: -1, defaults: { ease: 'none' } })
            .to('.animate-bg', {
                background: 'radial-gradient(20% 30% at 50% 0%,rgba(101, 179, 46, 1) 0%,rgba(0, 0, 0, 0) 100%)',
                duration: 0.5
            })
            .to('.animate-bg', {
                background: 'radial-gradient(16% 16% at 100% 0%,rgba(101, 179, 46, 1) 0%,rgba(0, 0, 0, 0) 100%)',
                duration: 0.5
            })
            .to('.animate-bg', {
                background: 'radial-gradient(20% 30% at 100% 50%,rgba(101, 179, 46, 1) 0%,rgba(0, 0, 0, 0) 100%)',
                duration: 0.5
            })
            .to('.animate-bg', {
                background: 'radial-gradient(16% 16% at 100% 100%,rgba(101, 179, 46, 1) 0%,rgba(0, 0, 0, 0) 100%)',
                duration: 0.5
            })
            .to('.animate-bg', {
                background: 'radial-gradient(20% 30% at 50% 100%,rgba(101, 179, 46, 1) 0%,rgba(0, 0, 0, 0) 100%)',
                duration: 0.5
            })
            .to('.animate-bg', {
                background: 'radial-gradient(16% 16% at 0% 100%,rgba(101, 179, 46, 1) 0%,rgba(0, 0, 0, 0) 100%)',
                duration: 0.5
            })
            .to('.animate-bg', {
                background: 'radial-gradient(20% 30% at 0% 50%,rgba(101, 179, 46, 1) 0%,rgba(0, 0, 0, 0) 100%)',
                duration: 0.5
            })
            .to('.animate-bg', {
                background: 'radial-gradient(16% 16% at 0% 0%,rgba(101, 179, 46, 1) 0%,rgba(0, 0, 0, 0) 100%)',
                duration: 0.5
            });
    }
});